import { useContext } from 'react';
import { AuthContext } from '../auth/AuthContext';

/**
 * The signed-in viewer's email, or null outside an AuthProvider. Unlike
 * `useAuth()` it never throws, so shared rows (rendered in tests and on pages
 * without auth) can use it to say "You".
 */
export function useViewerEmail(): string | null {
  return useContext(AuthContext)?.user?.email ?? null;
}

/** "You" for the viewer, otherwise the email as given. */
export function personLabel(email: string, viewerEmail: string | null): string {
  return viewerEmail && email.toLowerCase() === viewerEmail.toLowerCase() ? 'You' : email;
}

/** Compact form for dense rows: "You" or the email's local part. */
export function shortPersonLabel(email: string, viewerEmail: string | null): string {
  const label = personLabel(email, viewerEmail);
  return label === 'You' ? label : email.split('@')[0] || email;
}
